// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"3318":"3db8d1f353bf3451","5278":"4f8cf9aad508766b"}[chunkId] + ".js";
};